



























import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
@Component
export default class TeamStrategy extends Vue {
  @Prop() needNum: any
  @Prop() stageNum: any
  streList: any = [
    {
      img_url: require('../imgs/stra1.png'),
      text: '队长<br>发起组队',
    },
    {
      img_url: require('../imgs/stra2.png'),
      text: '关注“常青藤爸<br>爸语文学堂”公众号',
    },
    {
      img_url: require('../imgs/stra3.png'),
      text: '',
    },
    {
      img_url: require('../imgs/stra4.png'),
      text: '',
    },
  ]
  mounted() {
    if (this.stageNum === 1) {
      Vue.set(this.streList[2], 'text', `邀请${this.needNum}位<br>新用户`)
      Vue.set(this.streList[3], 'text', `获得活动奖励`)
    } else {
      Vue.set(this.streList[2], 'text', `邀请多位<br>新用户`)
      Vue.set(this.streList[3], 'text', `获得不同奖励`)
    }
  }
  showRule() {
    this.$emit('show_rule')
  }
  clickHandle(index) {
    if (index === 1) this.$emit('toService')
  }
}
